import { IComponentOptions } from 'angular';
import { RegentsPlanningTableCtrl } from './regents-planning-table.controller';

export const RegentsPlanningTableComponent: IComponentOptions = {
  bindings: {},
  controller: RegentsPlanningTableCtrl,
  template: require('./regents-planning-table.html'),
};
